import {
  createDirectus,
  rest,
  authentication,
  readItems,
  createItem,
  updateItem,
  deleteItem,
  readItem,
  aggregate,
  updateItems,
} from "@directus/sdk";

const client = createDirectus(location.origin)
  .with(authentication("cookie"))
  .with(rest());

async function get(limit, offset, filter, search, sort) {
  let query = {
    limit,
    offset,
    sort,
    fields: [
      "*,contacts.*,contacts.person_id.*,agents.*,agents.agents_id.*,agents.agents_id.person_id.*",
    ],
  };
  let obj = {};
  if (Object.keys(filter).length !== 0) {
    obj.filter = filter;
  }
  if (search.length > 0) obj.search = search;

  const totalCount = await client.request(
    aggregate("companies", {
      aggregate: { count: "*" },
      query: obj,
    })
  );
  const data = await client.request(
    readItems("companies", { ...obj, ...query })
  );
  return { totalCount: totalCount[0].count, data };
}
async function getById(id) {
  return await client.request(
    readItem("companies", id, {
      fields: [
        "*,contacts.*,contacts.person_id.*,agents.*,agents.agents_id.*,agents.agents_id.person_id.*",
      ],
    })
  );
}
async function create(data) {
  return await client.request(createItem("companies", data));
}

async function updateById(id, data) {
  return await client.request(updateItem("companies", id, data));
}

async function update(items, data) {
  return await client.request(updateItems("companies", items, data));
}
async function deleteById(id) {
  return await client.request(deleteItem("companies", id));
}
export default {
  get,
  create,
  update,
  deleteById,
  getById,
  updateById,
};
